module.exports = __webpack_public_path__ + "static/img/29.d509b9db.jpeg";